export const APP_NO_IMG='/img/no-image.webp';
export const APP_DELIVERY_CODE_SELF_EXPORT=3;
export const APP_DELIVERY_CODE_AUTO_EXPORT=1;
export const APP_DELIVERY_TIME_SELF_EXPORT=12;
export const APP_DELIVERY_TIME_AUTO_EXPORT=16;